export default  {
  'name': 'ams',
  'version': '0.1.0',
  'graphqlEndpoint': 'https://nukeagm.easysolar.org',
  'baseUrl': 'https:'
}